import Validation from '@core/logic/Validation'
import ILPPortfolioV2 from '@master/model/kyc-form/ILPPortfolioV2'
import { BasicProductV2 as BasicProduct } from '@master/model/kyc-form/product/BasicProductV2'

export default class ILPPortfolioValidation extends Validation {
  validate (ilpPortfolio: ILPPortfolioV2[], rcmd: BasicProduct[], belongsTo: string) {
    this.belongsTo = belongsTo
    const { getMessages, ADD, REQUIRE, WHEN } = this.validator()
    const ilpRcmd = rcmd.filter(product => product.isIlpPlan)

    ilpRcmd.forEach(ilp => {
      const foundIlp = ilpPortfolio.find(portfolio => portfolio.name === ilp.productName)
      ADD(WHEN((!foundIlp || foundIlp.funds.length === 0), () => {
        return `At least one subfund for ${ilp.productName} must be filled when product recommended`
      }), ['ILP/Sub funds'])
    })

    ilpPortfolio.forEach(ilp => {
      ilp.funds.forEach(fund => {
        ADD(WHEN(!this.isEmpty(ilp.name), REQUIRE(fund.name, `ILP Portfolio ${ilp.name} Fund name must be filled when ILP Portfolio name exists`)), ['ILP/Sub funds'])
        ADD(WHEN(!this.isEmpty(ilp.name), () => {
          if (fund.invAmt && fund.invAmt !== 0) return null
          return `ILP Portfolio ${ilp.name} Investment amount must be filled when ILP Portfolio name exists`
        }), ['ILP/Sub funds'])
      })
    })

    return getMessages()
  }
}
